import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux'
import BannerDashboard from '../../components/common/BannerDashboard'
import Banner from "../../components/common/Banner";
import { USER_DATA, USER_EMAIL_VERIFY_CODE,USER_PARENT,STUDENT_STATUS } from "../../helpers/constants";
import Sidebar from "../../components/layout/Sidebar";
//import { USER_DATA,USER_EMAIL_VERIFY_CODE,  } from '../../helpers/constants'
import { isUnauthenticatedRequest } from '../../helpers/utilities'
import { DIPLOMES } from "../../helpers/dummies";
import {setCurrentUser, setEmailCount} from '../../store/actions'
import {sendCodeToUserToVerifyEmail, submitCodeToVerifyEmail, getCurrentUser, getCurrentUserFavoriteUniversities, getCurrentUserFavoriteOpportunities} from '../../services/authService';
import {getCountries, submitUserMandatoryFields} from '../../services/userMandatoryFields';
import { Button, Modal, Form, Container, Row, Col} from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
import Breadcrumbs from "../../components/common/Breadcrumbs";
import CommonIcon from "../../components/common/CommonIcon";

import VerificationInProgress from '../../assets/images/placeholders/verification-in-process.png';
import VerificationExpired from '../../assets/images/placeholders/verification-expired.png';
import VerificationSuccessfull from '../../assets/images/placeholders/verification-successfull.png';



class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    // init state
    this.state = {
      userName: "",
      userData: {},
      emailCodeWithPublicId:{verificationCode:'', publicId:''},
      failure:"",
      areAllFieldSelected:false,
      thankMessage:false,
      success:"",
      isEmailVerified: false,
      isUserVerified:false,
      codeSentEmail:false,
      currentUser:{},
      countryList:[],
      step:0,
      wait:'',
    //   eligibleQuestion:[],
    //   eligibleAnswer:[],
      mandatoryFields:{publicId:'', countryId:"", whatsapp_number:null, education_level:null, student_status:null},
      studentStatus:STUDENT_STATUS,
      educationLevel:DIPLOMES,
    };
    this.sendCodeToEmailAddress = this.sendCodeToEmailAddress.bind(this);
    this.submitCodeToEmailAddress = this.submitCodeToEmailAddress.bind(this);
    this.selectMandatoryFieldsValue = this.selectMandatoryFieldsValue.bind(this);
    this.submitMandatoryFields = this.submitMandatoryFields.bind(this);
    this.getCurrentUserInformation = this.getCurrentUserInformation.bind(this);
    this.currentUserFavUni = this.currentUserFavUni.bind(this);
    this.currentUserFavOppo = this.currentUserFavOppo.bind(this);
    this.getAllCountries = this.getAllCountries.bind(this);
  }

  componentDidMount() {
    try {
      // extract username
      let user = JSON.parse(localStorage.getItem(USER_DATA));
      let userPseudo = user.name.split(" ");
      this.setState({
        // userName: userPseudo[1],
        userData: user,
        mandatoryFields:{publicId:user?.publicId, countryId:"", whatsapp_number:"", education_level:"", student_status:""},
      });
      this.getCurrentUserInformation(user?.publicId);
            
      this.getAllCountries();
      // this.currentUserFavUni({publicId:user?.publicId, lookingFor:'university'})
      // this.currentUserFavOppo({publicId:user?.publicId, lookingFor:'opportunity'})
       user && this.sendCodeToEmailAddress(user?.publicId);
    } catch (error) {
      console.log(error);
    }
  }

  getAllCountries() {
    getCountries().then(resp=>this.setState({countryList:resp}));
}

currentUserFavUni(data) {
    getCurrentUserFavoriteUniversities(data).then(res=>{this.setState({favoriteUniversities:res})})
}

currentUserFavOppo(data) {
    getCurrentUserFavoriteOpportunities(data).then(res=>{this.setState({favoriteOpportunities:res})})
}

getCurrentUserInformation(userPublicId) {
    getCurrentUser(userPublicId).then(response=>
        {
            if (response) {
                this.props.onCurrentUser(response);
                this.setState({currentUser:response});
                
                response?.email_verified_at === null ? this.props.onCurrentUser({...this.props.currentUserInformationState, step:1}) : (response?.user?.countryId !== undefined && response?.user?.education_level != null && response?.user?.student_status != null && response?.user?.whatsapp_number != null) ? this.props.onCurrentUser({...this.props.currentUserInformationState, step:3}) : this.props.onCurrentUser({...this.props.currentUserInformationState, step:2});
                
                this.setState({
                    isUserVerified:(response?.user?.countryId !== null && response?.user?.education_level !== null && response?.user?.student_status !== null && response?.user?.whatsapp_number !== null) ? true: false,
                    isEmailVerified: response?.email_verified_at === null ? true : false,
                })  
            } else if (isUnauthenticatedRequest(response)) {
                this.props.onAppTokenAsked(true)
            } else {
                // this.props.onPreloaderToggled(false, "")
                console.error(response, "GET USER VERIFIED ERROR")
            }
        }
    ).catch(err=>console.log(err));
}

sendCodeToEmailAddress(userPublicId) {
    this.setState({wait:'Please wait...'});
    sendCodeToUserToVerifyEmail(userPublicId).then((response)=>{
        this.setState({wait:''});   
        this.setState({codeSentEmail:true})
    }).catch(err=>console.log(err, 'error'))
}
    
onChange = (e) => {
    if (e.target) {
        this.setState({emailCodeWithPublicId: {...this.state.emailCodeWithPublicId, verificationCode:e.target.value, publicId:this.state.userData?.publicId}})
    }
}
    
submitCodeToEmailAddress(e) {
        e.preventDefault();
        submitCodeToVerifyEmail(this.state.emailCodeWithPublicId).then((response)=>{
            if (response.errors && response.errors[0] && (response?.errors[0] == USER_EMAIL_VERIFY_CODE)) {
                this.setState({failure: response.errors[0], success:"" })
            }
            else if(!response.errors){
                this.setState({failure: "", success:"You are verified." })
                this.getCurrentUserInformation(this.state.currentUser?.user?.publicId);
                setTimeout(()=>{
                    this.setState({failure: "", emailCodeWithPublicId:{verificationCode:""} })
                    this.setState({isEmailVerified:false})
                    this.setState({codeSentEmail:false})
                },1000)
        }
    }).catch(err=>console.log(err, 'error'))
}

selectMandatoryFieldsValue(e) {
    if(e.target) {
        let {name, value} = e.target;
        this.setState({mandatoryFields:{...this.state.mandatoryFields, [name]:value}})
    }
}

submitMandatoryFields(e) {
    e.preventDefault();
    if(this.state.mandatoryFields.countryId == '' || this.state.mandatoryFields.education_level == '' || this.state.mandatoryFields.student_status == '' || this.state.mandatoryFields.whatsapp_number == '') {
        this.setState({areAllFieldSelected: true});
    }
    else {
        submitUserMandatoryFields(this.state.mandatoryFields).then((response) => {
            this.setState({mandatoryFields:{publicId:"", countryId:"", whatsapp_number:"", education_level:"", student_status:""}});
            this.setState({thankMessage: true});
            this.props.onCurrentUser({...this.props.currentUserInformationState, student_status:response?.student_status, whatsapp_number:response?.whatsapp_number, education_level:response?.education_level, countryId:response?.countryId, step:3});
        }).catch(error=>console.log("this is the error", error))
    }
    setTimeout(()=>{
        this.setState({areAllFieldSelected:false});
        this.setState({thankMessage:false});
    },2000)
}

  getUserData() {
    try {
      return JSON.parse(localStorage.getItem(USER_DATA));
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  render() {
    const { userName, userData } = this.state;
    const { isEmailVerified, failure, success, countryList, studentStatus, educationLevel,  areAllFieldSelected, thankMessage, currentUser} = this.state
     console.log("currentUserInformation",this.props.currentUserInformationState);    
    let {step} = this.props.currentUserInformationState;
   console.log("your step",step)
    return (
      <React.Fragment>
        {/* <div>
          <div className="p-4">
            <h4>
              Bienvenue{" "}
              {`${
                userData.profile && userData.profile === USER_PARENT.key
                  ? "Mr/Mme"
                  : ""
              }`}{" "}
              <strong>{userName}</strong> !
            </h4>
          </div>
        </div> */}
         
        <BannerDashboard>
                    <div className='row align-items-center justify-content-center h-100'>
                        <div className='col-6'></div>
                        <div className='col-6 text-white'>
                            <div className='student-banner-title fw-semibold'>Lorem Ipsum Dolor Sit Amet</div>
                            <div className='student-banner-sub-title mt-2'>This is a dummy banner</div>
                            <div className='student-banner-desc mt-4'>Lorem Ipsum Dolor Sit Amet</div>
                        </div>
                    </div>
                </BannerDashboard>
                 {                    
                    step === 1 && this.state.isEmailVerified &&
                        <Modal size="sm" show={step===1} centered backdrop="static" keyboard={false} animation={false} aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header>
                                <Form.Label className="mb-0 fw-bold">Email Varification
                                <button onClick={this.resendEmail}>Resend an Email</button>
                                </Form.Label>
                            </Modal.Header>
                            <Modal.Body className=''>
                                <Container className='p-0'>
                                    <Form>
                                        <Row>
                                            <Col className='col-12'>
                                                <Form.Control
                                                    type="text"
                                                    id="verification-code"
                                                    name="verification-code"
                                                    onChange={this.onChange}
                                                    placeholder="Verification Code"
                                                    value={this.state.emailCodeWithPublicId.verificationCode}
                                                    />
                                            </Col>
                                            {failure !== "" && <Col className="text-danger col-12 mt-2">{failure}</Col>}
                                            {success !== "" && <Col className="text-success col-12 mt-2">{success}</Col>}
                                        </Row>
                                        <Row className='mx-0 mt-3'>
                                            <Button disabled={this.state.wait} className='btn-discover' type="submit" onClick={this.submitCodeToEmailAddress}>Submit Code</Button>
                                        </Row>
                                    </Form>
                                    {
                                        this.state.wait ?
                                            <Form.Label className="text-danger d-block mt-2 mb-0">{this.state.wait}</Form.Label>
                                        :
                                            <Form.Label className="text-success d-block mt-2 mb-0">Kindly check your email to fill the code below to verify your email address.</Form.Label>
                                    }
                                </Container>
                            </Modal.Body>
                        </Modal>
                } 
                    {
                    
                    step === 2 && this.state.userData?.profile === 'student' &&
                        currentUser?.user?.whatsapp_number === null && currentUser?.user?.student_status === null && currentUser?.user?.education_level === null &&
                            <Modal show={!isEmailVerified && currentUser?.user?.whatsapp_number == null && currentUser?.user?.student_status == null && currentUser?.user?.education_level == null} centered backdrop="static" keyboard={false} animation={false} aria-labelledby="contained-modal-title-vcenter">
                                <Modal.Header>
                                    <Form.Label className="mb-0 fw-bold">Mandatory Fields</Form.Label>
                                </Modal.Header>
                                <Modal.Body className=''>
                                    <Container className='p-0'>
                                        {areAllFieldSelected && <div className='text-danger fw-bold'>All the fields are required.</div>}
                                        {thankMessage && <div className='text-success fw-bold'>Your data saved successfully.</div>}
                                        <Form>
                                            <Form.Row>                          
                                                <Form.Group as={Col} controlId="formGridState" className="col-12">
                                                    <Form.Label>Country</Form.Label>
                                                    <Form.Control as="select" required custom onChange={this.selectMandatoryFieldsValue} name="countryId">
                                                        {
                                                            countryList && countryList.length > 0 && countryList?.map(country=>{
                                                                return (
                                                                    <option key={country.id} value={country.id}>{country.name}</option>
                                                                )
                                                            })
                                                        }
                                                    </Form.Control>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridState" className="col-12">
                                                    <Form.Label>Education Level</Form.Label>
                                                    <Form.Control as="select" required custom onChange={this.selectMandatoryFieldsValue} name="education_level">
                                                        {
                                                            educationLevel?.map((level)=>{
                                                                return (
                                                                    <option key={level.value} value={level.value}>{level.label}</option>
                                                                )
                                                            })
                                                        }
                                                    </Form.Control>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridState" className="col-12">
                                                    <Form.Label>Student Status</Form.Label>
                                                    <Form.Control as="select" required custom onChange={this.selectMandatoryFieldsValue} name="student_status">
                                                        {
                                                            studentStatus?.map(status=>{
                                                                return (
                                                                    <option key={status} value={status}>{status}</option>
                                                                )
                                                            })
                                                        }
                                                    </Form.Control>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridState" className="col-12">
                                                    <Form.Label>WhatsApp Number</Form.Label>
                                                    <PhoneInput country={'fr'} value={this.state.mandatoryFields.whatsapp_number} onChange={whatsapp_number => this.setState({mandatoryFields:{...this.state.mandatoryFields, whatsapp_number:whatsapp_number}})} required  inputProps={{name: 'whatsapp_number'}} />
                                                </Form.Group>                        
                                            </Form.Row>
                                            <Button variant="primary" type="submit" onClick={this.submitMandatoryFields} className="w-100">Submit Information</Button>
                                        </Form>                    
                                    </Container>
                                </Modal.Body>
                            </Modal>                    
                }
              

                {/* Form with Verification Email Content */}
                {
                step===3 && !this.state.isEmailVerified && this.state.userData?.profile === 'student' && (this.state.userData?.countryId !== null && this.state.userData?.education_level !== null && this.state.userData?.student_status !== null && this.state.userData?.whatsapp_number !== null) &&
                    <div className="get-verified">
                        <Row className='align-items-center'>
                            <Col xs="7" className="get-verified-text">
                                Vérifiez votre statut étudiant pour accéder à du contenu et des offres exclusives!
                            </Col>
                            <Col xs="5" className='text-end'>
                                <button className='get-verified-btn' onClick={()=>this.props.history.push('/user-general-information')}>Être vérifié
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none" className='position-absolute '>
                                        <path d="M1.16907 6.00006H14.1495" stroke="#FDFDFD" strokeWidth="1.68421" strokeMiterlimit="10" strokeLinecap="round"/>
                                        <path d="M10.0584 0.947388L15.0286 6.00002L10.0584 11.0527" stroke="#FDFDFD" strokeWidth="1.68421" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </Col>
                        </Row>
                    </div>
                    }

                {/* In Process Message Content */}
                {
                    !this.state.isEmailVerified && this.state.isUserVerified && currentUser?.user?.checkedAccountAt === null && currentUser?.user?.reject_reason === null &&
                    <div className="get-verified verification-in-process">
                            <Row className='align-items-center'>
                                <Col xs="7" className="get-verified-text">La vérification de votre profil est en cours</Col>
                                <Col xs="5" className='text-end'>
                                <img src={VerificationInProgress} alt="Verification In Progress" className='img-fluid' />
                                </Col>
                            </Row>
                    </div>
                }

                    {/* Success Message Content */}
                    {
                       !this.state.isEmailVerified && currentUser?.user?.checkedAccountAt != null && currentUser?.user?.reject_reason == null &&
                            <div className="get-verified verification-successfull">
                                <Row className='align-items-center'>
                                    <Col xs="7" className="get-verified-text">
                                        <h3>Félicitations!</h3>
                                        Votre profil étudiant est vérifié!
                                        <p>Demandez à mettre à jour votre profil</p>
                                    </Col>
                                    <Col xs="5" className='text-end'>
                                    <img src={VerificationSuccessfull} alt="Verification In Progress" className='img-fluid' />
                                    </Col>
                                </Row>
                            </div>
                    }
                    
                    {/* failure Message Content */}
                    {
                        !this.state.isEmailVerified && currentUser?.user?.checkedAccountAt == null && currentUser?.user?.reject_reason != null &&
                            <div className="get-verified verification-expired">
                                <Row className='align-items-center'>
                                    <Col xs="7" className="get-verified-text">
                                        {currentUser?.user?.reject_reason}
                                        {/* Heureux que vous soyez elle mais nous ne pouvons pas vous vérifier en tant qu'étudiant actuel pour le moment, contactez-nous s'il y a un changement dans votre situation */}
                                    </Col>
                                    <Col xs="5" className='text-end'>
                                        <img src={VerificationExpired} alt="Verification In Progress" className='img-fluid' />
                                    </Col>
                                </Row>
                            </div>
                    }

      </React.Fragment>
    );
  }
}
  

Dashboard.propTypes = {
  currentUserInformationState:PropTypes.object,
  onCurrentUser: PropTypes.func,
}   
const mapStateToProps = state => ({    
  currentUserInformationState:state.currentUserInformation,
})
const mapDispatchToProps = dispatch => ({
  onCurrentUser: (currentUser) => dispatch(setCurrentUser(currentUser)),
})
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
